import React from 'react';
import { Box } from '@/components/gluestack/box';
import { ButtonWrapper } from '@/components/ui/ButtonWrapper';
import { ArrowUp02Icon } from '@hugeicons-pro/core-stroke-rounded';

interface IFloatingScrollButtonProps {
  /**
   * Whether the button should be visible
   */
  isVisible: boolean;
  /**
   * Function to call when button is pressed
   */
  onPress: () => void | Promise<void>;
  /**
   * Text to display on the button
   */
  text: string;
  /**
   * Optional custom positioning from top
   */
  topOffset?: string;
}

export function FloatingScrollButton({
  isVisible,
  onPress,
  text,
  topOffset = 'top-4',
}: IFloatingScrollButtonProps) {
  if (!isVisible) return null;

  return (
    <Box className={`absolute ${topOffset} w-full items-center`}>
      <ButtonWrapper
        icon={ArrowUp02Icon}
        size="sm"
        action="primary"
        variant="outline"
        className="bg-background-0 dark:bg-black"
        onPress={onPress}
        text={text}
      />
    </Box>
  );
} 